import styled, { css, keyframes } from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { HEADER_HEIGHT_PX } from 'Constants/Navigation'

type ContainerProps = {
  fullscreen?: boolean
  inverse?: boolean
}

const containerFullscreenCss = ({ fullscreen }: ContainerProps) =>
  fullscreen &&
  css`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    padding-top: ${HEADER_HEIGHT_PX.MOBILE}px;
    background-color: ${themeGet('colors.background.screen')};

    @media screen and (min-width: ${themeGet('breakpoints.1')}) {
      padding-top: ${HEADER_HEIGHT_PX.DESKTOP}px;
    }
  `

const containerInverseCss = ({ inverse }: ContainerProps) =>
  inverse &&
  css`
    color: ${themeGet('colors.text.inverse')};
  `

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const shouldForwardProp = (prop: string) =>
  !['fullscreen', 'inverse'].includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  display: flex;
  color: ${themeGet('colors.primary500')};

  > svg {
    animation: ${rotate} 1s linear infinite;
    transform-origin: center;
  }

  ${containerFullscreenCss}
  ${containerInverseCss}
`
